/**
 * @generated SignedSource<<3577f6e2adc0356dd18133fb234d21f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type ServicePeriodStatus = "CONFIRMED" | "PROPOSED" | "%future added value";
export type ExpenseInvoiceFilter = {
  expenseCategory?: ExpenseCategory | null | undefined;
  includeDeleted?: boolean | null | undefined;
  searchTerm?: string | null | undefined;
  serviceMonth?: string | null | undefined;
  servicePeriodStatus?: ServicePeriodStatus | null | undefined;
  supplierIdentifier?: string | null | undefined;
  withoutExpenseCategory?: boolean | null | undefined;
  withoutServicePeriod?: boolean | null | undefined;
};
export type IncomingInvoicesPaginationQuery$variables = {
  after?: string | null | undefined;
  filter?: ExpenseInvoiceFilter | null | undefined;
  first?: number | null | undefined;
};
export type IncomingInvoicesPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IncomingInvoicesView_invoices">;
};
export type IncomingInvoicesPaginationQuery = {
  response: IncomingInvoicesPaginationQuery$data;
  variables: IncomingInvoicesPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncomingInvoicesPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "IncomingInvoicesView_invoices"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncomingInvoicesPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExpenseInvoiceConnection",
        "kind": "LinkedField",
        "name": "expenseInvoices",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseInvoiceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExpenseInvoice",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supplierName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servicePeriodStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servicePeriodEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servicePeriodStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseCategory",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseCategoryOverride",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netAmountInEuro",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netAmountInServiceMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paidDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasDocument",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedInFastBillAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter"
        ],
        "handle": "connection",
        "key": "IncomingInvoicesView_expenseInvoices",
        "kind": "LinkedHandle",
        "name": "expenseInvoices"
      }
    ]
  },
  "params": {
    "cacheID": "cdf1c201a7048edd7ec4fa674d28694a",
    "id": null,
    "metadata": {},
    "name": "IncomingInvoicesPaginationQuery",
    "operationKind": "query",
    "text": "query IncomingInvoicesPaginationQuery(\n  $after: String\n  $filter: ExpenseInvoiceFilter\n  $first: Int = 100\n) {\n  ...IncomingInvoicesView_invoices_G9cLv\n}\n\nfragment IncomingInvoicesView_invoices_G9cLv on Query {\n  expenseInvoices(first: $first, after: $after, filter: $filter) {\n    totalCount\n    edges {\n      node {\n        id\n        supplierName\n        invoiceNumber\n        invoiceDate\n        servicePeriodStart\n        servicePeriodEnd\n        servicePeriodStatus\n        expenseCategory\n        expenseCategoryOverride\n        netAmountInEuro\n        netAmountInServiceMonth\n        currency\n        netAmount\n        paidDate\n        hasDocument\n        deletedInFastBillAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "66afba5aaaef10d5e525ce5db24866b5";

export default node;
